import { render, staticRenderFns } from "./pethouse.vue?vue&type=template&id=4c67a47a&scoped=true&"
import script from "./pethouse.vue?vue&type=script&lang=js&"
export * from "./pethouse.vue?vue&type=script&lang=js&"
import style0 from "./pethouse.vue?vue&type=style&index=0&id=4c67a47a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67a47a",
  null
  
)

export default component.exports